import React from 'react';
import { Container } from '@ui';
import { SkeletonButton } from '@ui/buttons';

// Directly above the rows it changes, rather than in a panel with the column notices: this is an
// action on the table, not an explanation of the request.
//
// It exists because the alternative was a paragraph explaining additive `columns`, first reads and
// spec-declared payload keys — an accurate account of a problem the analyst did not cause and cannot
// act on except in one way. The one way is this.
export const LoadColumnsButton = ({ label, onLoad }) => (
  <Container bottom={12}>
    <SkeletonButton onClick={onLoad}>{label}</SkeletonButton>
  </Container>
);
